import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { pageTitle } from '../../helper';
import Cta from '../Cta';
import PageHeading from '../PageHeading';
import Div from '../Div';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import {RowsPhotoAlbum} from "react-photo-album";
import "react-photo-album/rows.css";
import { Helmet } from 'react-helmet';

export default function AboutPage() {
  const { t, i18n } = useTranslation();
  const isEn = i18n.language === 'en';
  const prefix = isEn ? '/en' : '';

  pageTitle('O nás');
  const photos = [
    { src: "/images/stablerecords/stable_records_rezije.webp", width: 1024, height: 768, alt: "Řežie nahrávacího studia Stable Records u Prahy" },
    { src: "/images/stablerecords/Marshall_orange.webp", width: 1024, height: 1365, alt: "Marshall a Orange zesilovače ve Stable Records studiu" },
    { src: "/images/stablerecords/stable-records-vocals-zpev-nahravani.webp", width: 1080, height: 1440, alt: "Nahrávání zpěvu ve Stable Records studiu u Prahy" },
    { src: "/images/stablerecords/Stable-records-control-room.webp", width: 1024, height: 768, alt: "Control room — mixážní pult Stable Records studio" },
    { src: "/images/stablerecords/stablerecords-cute.webp", width: 1024, height: 768, alt: "Kapela Cute při nahrávání ve Stable Records studiu" },
    { src: "/images/stablerecords/stablerecords-drums.webp", width: 1024, height: 768, alt: "Nahrávání bicích nástrojů ve Stable Records studiu" },
    { src: "/images/stablerecords/stablerecords-recordroom.webp", width: 1024, height: 768, alt: "Nahrávací místnost Stable Records — profesionální akustika" },
    { src: "/images/stablerecords/stablerecords-rezije.webp", width: 1024, height: 768, alt: "Řežie Stable Records studio — Logic Pro a špičkové vybavení" },
    { src: "/images/stablerecords/stable-records-jazz-kontrabass-piano.webp", width: 1024, height: 1365, alt: "Nahrávání jazzu — kontrabas a klavír ve Stable Records" },
    { src: "/images/stablerecords/stable-records-drums-pearl.webp", width: 1080, height: 1440, alt: "Bicí souprava Pearl ve Stable Records nahrávacím studiu" },
    { src: "/images/stablerecords/stable-records-live.webp", width: 1024, height: 768, alt: "Live nahrávání kapely ve Stable Records studiu" },
    { src: "/images/stablerecords/stable-records-myschak.webp", width: 1024, height: 768, alt: "Nahrávání ve Stable Records studiu u Prahy" },
    { src: "/images/stablerecords/stable-records-housle-recording.webp", width: 1024, height: 1365, alt: "Nahrávání houslí ve Stable Records nahrávacím studiu" },
    { src: "/images/stablerecords/stable-records-hoodermaniax.webp", width: 1024, height: 768, alt: "Kapela při nahrávání ve Stable Records studiu" },
    { src: "/images/stablerecords/stable-records-live-band.webp", width: 1024, height: 768, alt: "Živé nahrávání celé kapely ve Stable Records" },
    { src: "/images/stablerecords/fender-mustang-combo-silverplate.webp", width: 1024, height: 1365, alt: "Fender Mustang combo zesilovač — vybavení Stable Records studia" },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
        <Helmet>
      <title>{t('about.metaTitle')}</title>
      <link rel="icon" href="/stablerecords.ico" />
      <meta name="description" content={t('about.metaDescription')} />
    </Helmet>
      <PageHeading
        title={t('about.pageTitle')}
        bgSrc="images/about_hero_bg.jpeg"
        pageLinkText={t('about.pageTitle')}
      />
      <Spacing lg="50" md="80" />
      <Div className="container">
        <Div className="row">
          <Div className="col-xl-7 col-lg-7">
            <SectionHeading
              title={t('about.sectionTitle')}
              subtitle={t('about.sectionSubtitle')}
            >
              <Spacing lg="30" md="20" />
              <div dangerouslySetInnerHTML={{ __html: t('about.content') }} />
              <Spacing lg="30" md="30" />
              <Div className="cs-separator cs-accent_bg"></Div>
              <Spacing lg="25" md="40" />
            </SectionHeading>
          </Div>
          <Div className="col-lg-3 offset-xl-2">
            <img
              src="/images/stablerecords/mastix.jpg"
              alt="Tým ve studiu Stable Records"
              className="w-100 cs-radius_15"
            />
            <Spacing lg="25" md="25" />
          </Div>
        </Div>
      </Div>
      <Spacing lg="75" md="55" />
      <RowsPhotoAlbum photos={photos} />
      <Spacing lg="150" md="80" />
      <Div className="container">
        <Cta
          title={t('about.ctaTitle')}
          btnText={t('about.ctaBtn')}
          btnLink={'/kontakt'}
          bgSrc="/images/cta_bg.jpeg"
        />
      </Div>
    </>
  );
}